(function () {
  "use strict";

  InviteTraineesCtrl.$inject = ['$scope', '$routeParams', 'seriesTraineesResource', 'courseTraineesResource', '$rootScope', 'gridFormatters', '$window', 'userGridUtils', 'notificationService', '$timeout', 'trainerPrivilege', '$location', 'mtypes', 'accountFeatures'];
  angular
    .module('trainerWebApp.controllers')
    .controller('InviteTraineesCtrl', InviteTraineesCtrl);

  function InviteTraineesCtrl($scope, $routeParams, seriesTraineesResource, courseTraineesResource, $rootScope, gridFormatters,
                              $window, userGridUtils, notificationService, $timeout, trainerPrivilege, $location, mtypes, accountFeatures) {

    $window.document.title = $routeParams.seriesId ? "Course" : "Course";
    $window.document.title += " | Mindflash Training Management System";

    $scope.seriesId = $routeParams.seriesId;
    $scope.courseId = $routeParams.courseId;
    $scope.makeCourseRequired = true;
    var userRole = trainerPrivilege.roles();

    var queryParams = $location.search();

    $scope.montara = queryParams.course;

    if (!userRole.canInviteUsers) {
      if ($scope.courseId)
        $location.path('/TMS/Distribute_Course/' + $scope.courseId + '/trainees');
      else
        $location.path('/TMS/Series/' + $scope.seriesId + '/trainees');
    }

    var accountTrainees = $scope.resolvedData.trainees;

    accountTrainees = $scope.gridData = accountTrainees.sort(userGridUtils.sort.byPersonName);
    $scope.traineeCount = $scope.gridData.length;
    $scope.accountGroups = $scope.resolvedData.groups;

    var selectedGroup = {
      id: -1,
      name: 'All',
      traineeIds: accountTrainees   //This is only used to count, so it's ok that these aren't ids here
    };
    $scope.accountGroups.splice(0, 0, selectedGroup);

    $scope.searchChanged = updateFilter;

    $scope.courseStatus = $scope.resolvedData.courseStatus;

    if (!$scope.gridCommands)
      $scope.gridCommands = {};
    var gridCommands = $scope.gridCommands;

    $scope.gridInfoGroups = {
      options: {editable: false,
        selectable: true,
        enableCellNavigation: true,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        forceSyncScrolling: $scope.accountGroups.length < 100
      },
      columns: [
        {
          id: "name",
          name: "Groups",
          field: "name", width: 300, cssClass: "cell-title", formatter: gridFormatters.groupNameFormatter
        }
      ],
      onClick: onGroupRowClick,
      rowMetadataProvider: groupRowMetadataProvider,
      data: []
    };

    $scope.gridInfoTrainees = {
      options: {
        editable: false,
        enableCellNavigation: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        multiColumnSort: true,
        forceSyncScrolling: accountTrainees.length < 500
      },
      columns: [
        {id: "name", name: "Name", field: "name", width: 250, cssClass: "cell-title", sortable: true},
        {id: "email", name: "Email", field: "email", width: 350, cssClass: "cell-title", sortable: true,
          formatter: gridFormatters.traineeEmailWithInviteFormatter
        }
      ],
      onRowsChanged: onRowsChanged,
      onRowCountChanged: onRowCountChanged,
      filterFn: filterer,
      rowMetadataProvider: traineeRowMetadataProvider,
      data: [],
      includeSelectCheckbox: true,
      checkboxSelectionFormatter: checkboxSelectionFormatter,
      onSelectedRowsChanged: onSelectedRowsChanged
    };

    if ($scope.isUsernameEnabled) {
      $scope.gridInfoTrainees.columns.push({id: "username",
        name: "Username",
        field: "username",
        minWidth: 80,
        headerCssClass: "header-column",
        sortable: true
      });
    }

    getInvitedTraineeIds();

    $scope.selectedUserIdsForInvitation = [];
    $scope.getApiVersion = function(features) {
      return features.indexOf(mtypes.featureEntry.inviteV2) == -1 ? 1 : 2;
    }
    $scope.MAX_NUM_OF_TRAINEES_PER_INVITATION_BATCH = 10000;
    $scope.showMaxNumOfTraineesPerInvitationReached = function() {
      // TODO: launch the modal service for a better UX
      // for now, use alert to block the I/O so that the flow can immediately return
      alert('You can only invite up to ' + $scope.MAX_NUM_OF_TRAINEES_PER_INVITATION_BATCH + ' trainees at any given time. Please modify the selection and try again.');
    }
    $scope.selectedRowsCount = 0;

    function onSelectedRowsChanged(args, value) {
      $scope.selectedRowsCount = value.length;
      $scope.selectedUserIdsForInvitation = value;

      refreshInviteButtonState();
    }

    function traineeRowMetadataProvider(row) {
      if (!this.getItem(row))
        return {cssClasses: 'enabledRow'};

      return this.getItem(row).canBeInvited ? {cssClasses: 'enabledRow'} : {cssClasses: 'disabledRow'};
    }

    function groupRowMetadataProvider(row) {
      if (!this.getItem(row))
        return {cssClasses: 'shiftedRow'};
      return this.getItem(row).name.toLowerCase() === 'all' ? {cssClasses: 'boldedRow'} : {cssClasses: 'shiftedRow'};
    }

    function filterer(itemToFilter, args) {
      if (!args || !args.nameCriteria) return true;
      return userGridUtils.filter.byPersonNameEmailUserName(itemToFilter, args.nameCriteria);
    }

    function updateFilter() {
      $scope.filterData = { nameCriteria: $scope.traineeSearchCriteria };
    }

    function onGroupRowClick(item, targetClasses) {
      selectedGroup = item;
      return loadTraineesForGroup(item);
    }

    this.onGroupRowClick = onGroupRowClick;

    function arrayToLookup(arr) {
      var lookup = {};
      for (var i = 0; i < arr.length; i++)
        lookup[arr[i]] = true;
      return lookup;
    }

    function preselectInvitedTrainees() {
      gridCommands.setSelectedRows(getInvitedTraineeIdx());
    }

    function getInvitedTraineeIdx() {
      var cannotBeInvitedIdx = [];

      for (var i = 0; i < $scope.gridData.length; i++) {
        if (!$scope.gridData[i].canBeInvited) {
          cannotBeInvitedIdx.push(i);
        }
      }
      return cannotBeInvitedIdx;
    }

    function getInvitedTraineeIds() {
      var cannotBeInvitedIds = [];
      for (var i = 0; i < $scope.gridData.length; i++) {
        if (!$scope.gridData[i].canBeInvited) {
          cannotBeInvitedIds.push($scope.gridData[i].id);
        }
      }
      return cannotBeInvitedIds;
    }

    function loadTraineesForGroup(group) {
      var traineesInGroup = restoreSortIn(unsortedTraineesFor(group));
      $scope.gridData = traineesInGroup;
      viewData = $scope.traineeSearchCriteria ? filterViewBySearchCriteria() : $scope.gridData;
      preselectInvitedTrainees(traineesInGroup);
      gridCommands.cleanSelection();
    }

    function filterViewBySearchCriteria() {
      return _.filter($scope.gridData, function (trainee) {
        return userGridUtils.filter.byPersonNameEmailUserName(trainee, $scope.traineeSearchCriteria);
      });
    }

    function unsortedTraineesFor(group) {
      if (group.id === -1) {
        return accountTrainees;
      }
      else {
        var ids = arrayToLookup(group.traineeIds);
        return _.filter(accountTrainees, function (trainee) {
          return ids[trainee.id];
        });
      }
    }

    var currentSortColumn;

    function restoreSortIn(data) {
      currentSortColumn = gridCommands.sort();
      if (!currentSortColumn) return data.sort(userGridUtils.sort.byPersonName);
      switch (currentSortColumn.columnId) {
        case "name" :
        {
          return data.sort(userGridUtils.sort.byPersonName);
          break;
        }
        case "email" :
        {
          return data.sort(sortByEmail);
          break;
        }
      }
    }

    function sortByEmail(a, b) {
      var aEmail = a.email.toLowerCase();
      var bEmail = b.email.toLowerCase();
      var sign = currentSortColumn.sortAsc ? 1 : -1;
      return ((aEmail < bEmail) ? -1 : ((aEmail > bEmail) ? 1 : 0)) * sign;
    }

    var viewData = [];

    function onRowsChanged(args, items) {
      viewData = items;
      refreshInviteButtonState();
    }

    function onRowCountChanged(args, items) {
      viewData = items;
      refreshInviteButtonState();
      $scope.traineeCount = viewData.length;
    }

    function showSpinner() {
      $rootScope.$broadcast('$showLoadingSpinner', true);
      refreshInviteButtonState();
    }

    function hideSpinner() {
      $rootScope.$broadcast('$showLoadingSpinner', false);
      refreshInviteButtonState();
    }

    function refreshInviteButtonState() {
      calculateTraineesToInvite();
      buildInviteButtonText();
    }

    function calculateTraineesToInvite() {
      var traineesToInvite = 0;
      _.each(viewData, function (trainee) {
        if (trainee.canBeInvited && $scope.selectedUserIdsForInvitation.indexOf(trainee.id) != -1) {
          traineesToInvite++;
        }
      });
      $scope.traineesToInvite = traineesToInvite;
    }

    function buildInviteButtonText() {
      var label = inviting ? "Inviting... (" + $scope.traineesToInvite + ')' : $scope.traineesToInvite == 0 ? 'Invite' : 'Invite (' + $scope.traineesToInvite + ')';

      $scope.inviteButtonState = {
        enabled: $scope.traineesToInvite > 0 && !inviting,
        text: label
      };
    }

    var spinnerTimeout;
    var inviting = false;

    $scope.addAllTrainees = function () {
      var idsToInvite = _.difference($scope.selectedUserIdsForInvitation, getInvitedTraineeIds());
      if (idsToInvite.length == 0) return;
      if (idsToInvite.length > $scope.MAX_NUM_OF_TRAINEES_PER_INVITATION_BATCH) {
        $scope.showMaxNumOfTraineesPerInvitationReached();
        return;
      }

      inviting = true;
      buildInviteButtonText();

      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var invitationGrammer = idsToInvite.length > 1 ? 'invitations':'invitation';

      if ($scope.seriesId) {
        courseTraineesResource.inviteTraineesToCourse([$scope.seriesId], idsToInvite, $scope.makeCourseRequired, dateString, $scope.getApiVersion(accountFeatures.features), function (result) {
          refreshData(clearAfterInvite);
          var notification = {message: idsToInvite.length + ' course ' + invitationGrammer + ' sent.', pageToShow: 'Series', close: true, displayOrder: 2}
          notificationService.setNotification(notification);
          $timeout(function() {
            notificationService.removeNotification(notification);
          }, 5000);
        }, function (error) {
          clearAfterInvite();
        });
      }
      else {
        courseTraineesResource.inviteCourseTrainees($scope.courseId, idsToInvite, $scope.makeCourseRequired, dateString, function (result) {
          refreshData(clearAfterInvite);
          var notification = $scope.courseStatus.status == 107000100 ?
            {message: idsToInvite.length + ' course ' + invitationGrammer + ' will be sent once the course is activated.', pageToShow: 'Course', close: true, displayOrder: 2} :
            {message: idsToInvite.length + ' course ' + invitationGrammer + ' sent.', pageToShow: 'Course', close: true, displayOrder: 2}
          notificationService.setNotification(notification);
          $timeout(function() {
            notificationService.removeNotification(notification);
          }, 5000);
        }, function (error) {
          clearAfterInvite();
        });
      }
    };

    function clearAfterInvite() {
      inviting = false;
      clearTimeout(spinnerTimeout);
      hideSpinner();
      gridCommands.cleanSelection();
    }

    function refreshData(cb) {
      cb = cb || function () {
      };

      if ($scope.seriesId) {
        seriesTraineesResource.inviteSetup($scope.seriesId, function (result) {
          accountTrainees = result.trainees;
          $scope.accountGroups = result.groups;
          $scope.accountGroups.splice(0, 0, {id: -1, name: 'All', trainees: accountTrainees});

          restoreSelectedGroup();
          cb();
        });
        return;
      }

      courseTraineesResource.inviteSetup($scope.courseId, function (result) {
        accountTrainees = result.trainees;
        $scope.accountGroups = result.groups;
        $scope.accountGroups.splice(0, 0, {id: -1, name: 'All', trainees: accountTrainees});

        restoreSelectedGroup();
        cb();
      });
    }

    function restoreSelectedGroup() {
      var updatedSelectedGroup = $.grep($scope.accountGroups, function (e) {
        return e.id == selectedGroup.id
      });
      loadTraineesForGroup(updatedSelectedGroup[0]);
    }


    $scope.getBackUrl = function () {
      return $scope.seriesId ? "#/TMS/Series/" + $scope.seriesId + "/trainees" : "#/TMS/Distribute_Course/" + $scope.courseId + "/trainees";
    };

    function checkboxSelectionFormatter(row, cell, value, columnDef, dataContext) {
      if (dataContext && !dataContext.canBeInvited) return "";
      var selectedRows = gridCommands.getSelectedRows();
      var checked = !!~selectedRows.indexOf(row);
      return checked ? "<input type='checkbox' checked='checked'>" : "<input type='checkbox'>";
    }

    $scope.$watch('traineeSearchCriteria', updateFilter);
  }

})();
